import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logger } from "@/utils/logger";
import { useBuildingStore } from "@/hooks/useBuildingStore";

interface UpdateBuildingNameParams {
  buildingId: string;
  name: string;
}

export const useUpdateBuildingName = () => {
  const queryClient = useQueryClient();
  const store = useBuildingStore();

  return useMutation({
    mutationFn: async ({ buildingId, name }: UpdateBuildingNameParams) => {
      void logger.info("ui", "update-name-start", "Updating building name", { buildingId, name });
      const res = await store.updateBuildingName(buildingId, name);
      void logger.info("ui", "update-name-saved", "Building name updated", { buildingId, name });
      return res;
    },
    onSuccess: (data, variables) => {
      void logger.info(
        "ui",
        "update-name-complete",
        "Building name update success, invalidating queries"
      );

      // Invalidate and refetch building data
      queryClient.invalidateQueries({
        queryKey: ["building-full-data", variables.buildingId],
      });

      queryClient.invalidateQueries({
        queryKey: ["building", variables.buildingId],
      });

      // Success/error toasts are owned by the caller (Buildings.tsx, which uses
      // localized i18n strings) — firing one here too would double-toast.
    },
    onError: (error) => {
      void logger.error("ui", "update-name-error", "Building name update failed", error as Error);
    },
  });
};
